import { PrivacyLinks } from '@izettle/constants';
export const getPrivacyPolicyLink = (locale) => {
    const link = PrivacyLinks.get(locale);
    if (!link) {
        throw new Error(`Privacy policy link not found for locale '${locale}'`);
    }
    return link;
};
